module.exports = __webpack_public_path__ + "img/columbia_shipmanagement_logo.12446949.jpeg";